/* eslint-disable import/no-cycle */

import React, { useContext, useEffect } from 'react';
import { FunctionField, ReferenceField, SelectField, TextField, useTranslate } from 'react-admin';
import { Box, Link, Tooltip } from '@material-ui/core';
import resourceSlug from '../../constant/resource-slug';
import CustomLinkField from '../../base/components/ra/fields/customLink.field';
import PaymentListActions from './components/PaymentList/PaymentListActions';
import PaymentDetailsDrawer from './components/PaymentDetailsDrawer';
import { NavigationContext } from '../../App';
import { CustomizedNoPageList } from '../../base/components/customized/CustomizedNoPageList';
import PaymentFilters from './components/PaymentList/PaymentFilters';
import PaymentStatus from './components/PaymentStatus';
import { DateField } from '../../base/components/ra/fields';
import { DATETIME_DISPLAY_FORMAT } from '../../constant';
import AmountField from '../../base/components/ra/fields/amount.field';
import { usePaymentIdSync } from './hooks/usePaymentIdSync';
import { PAYMENT_METHOD } from '../../constant/invoice';
import { truncate } from '../../services/util/stringUtil';
import ProofsPreview from './components/ProofPreview';

const PaymentList = (props) => {
  const t = useTranslate();
  const { setNavigationData } = useContext(NavigationContext);
  const { setPaymentId } = usePaymentIdSync();

  useEffect(() => {
    setNavigationData({
      pageTitleInfo: {
        label: t('resources.payment.name'),
      },
    });

    return () => {
      setNavigationData({});
    };
  }, [t]);

  return (
    <>
      <CustomizedNoPageList
        {...props}
        filters={<PaymentFilters />}
        actions={<PaymentListActions />}
        disabledAutoRefetch
        rowClick={(id) => setPaymentId(id)}
        syncWithLocation
        sort={{
          field: 'createdAt',
          order: 'DESC',
        }}
      >
        <TextField source="id" label="resources.payment.fields.id" sortable={false} />
        <ReferenceField label="resources.group.name" sortable={false} reference={resourceSlug.GROUP} source="groupId">
          <TextField source="name" />
        </ReferenceField>
        <DateField
          source="createdAt"
          label="resources.payment.fields.createdTime"
          dateFormat={DATETIME_DISPLAY_FORMAT}
          sortable={false}
        />
        <DateField
          source="completedAt"
          label="resources.payment.fields.completedTime"
          dateFormat={DATETIME_DISPLAY_FORMAT}
          sortable={false}
        />
        <SelectField
          source="paymentMethod"
          label="resources.payment.fields.paymentMethod"
          choices={Object.values(PAYMENT_METHOD).map((method) => ({
            id: method,
            name: t(`common.paymentMethod.${method}`),
          }))}
          sortable={false}
        />
        <AmountField
          source="amount"
          sortable={false}
          label="resources.payment.fields.amount"
          symbol={(record) => record.currencyCode}
        />
        <CustomLinkField
          source="payer"
          label="resources.payment.fields.payer"
          component={(record) => (record.payerId ? Link : Box)}
          href={(record) => `/#/${resourceSlug.USER}/${record.payerId}/show`}
          title={(record) => record.payerUsername}
          sortable={false}
        />
        <FunctionField
          label="resources.payment.fields.description"
          sortable={false}
          render={(record) =>
            record.description ? (
              <Tooltip title={record.description}>
                <Box>{truncate(record.description, 15)}</Box>
              </Tooltip>
            ) : (
              '-'
            )
          }
        />
        <FunctionField
          label="resources.payment.fields.proofs"
          render={(record) => <ProofsPreview urls={record.paymentProofUrls} />}
          sortable={false}
        />
        <FunctionField
          source="paymentStatus"
          label="resources.payment.fields.status"
          render={(record) => <PaymentStatus status={record.status} />}
          sortable={false}
        />
      </CustomizedNoPageList>
      <PaymentDetailsDrawer />
    </>
  );
};

export default PaymentList;
